import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { ISO_FORMAT } from "../DatePicker/constants";
import PRESET_OPTIONS from "./constants";
dayjs.extend(customParseFormat);
export function turnValueArrayToJSDate(value) {
  var arr = [];
  for (var i = 0; i < value.length; i += 1) {
    if (!Number.isNaN(Date.parse(value[i]))) arr.push(dayjs(value[i], ISO_FORMAT).toDate());
  }
  return arr;
}
export function stateObjectToArray(stateObject) {
  return [stateObject.startDate ? stateObject.startDate : "", stateObject.endDate ? stateObject.endDate : ""];
}
export function determineFallbackDefault(toOrFrom, defaultValueFromPreset) {
  if (defaultValueFromPreset) {
    var selectedOption = PRESET_OPTIONS.find(function (item) {
      return item.key === defaultValueFromPreset;
    });
    return selectedOption[toOrFrom];
  }
  return "";
}
export function createRangeEventObject(onChangeObjects) {
  var startDate = onChangeObjects.startDate,
    endDate = onChangeObjects.endDate;
  return {
    value: [startDate.value || "", endDate.value || ""],
    isValid: [startDate.isValid, endDate.isValid],
    errorMessage: [startDate.errorMessage, endDate.errorMessage],
    textValue: [startDate.textValue, endDate.textValue]
  };
}